<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component v-if="$route.meta.keepAlive" :is="Component" />
    </keep-alive>
    <component v-if="!$route.meta.keepAlive" :is="Component" />
  </router-view>
  <!-- <router-view></router-view> -->
</template>

<script>
import { useTheme } from "./theme";
export default {
  setup() {
    const { initializeTheme } = useTheme();
    initializeTheme(); // 初始化主题
  },
  data() {
    return {
      // isDark: false, // 用于跟踪当前主题状态
    };
  },
  methods: {
    // toggleTheme() {
    //   this.isDark = !this.isDark;
    //   const newTheme = this.isDark ? "dark" : "light";
    //   document.documentElement.setAttribute("data-theme", newTheme);
    // },
    // initializeTheme() {
    //   const savedTheme =
    //     document.documentElement.getAttribute("data-theme") || "dark"; // 默认 dark
    //   this.isDark = savedTheme === "dark";
    //   document.documentElement.setAttribute("data-theme", savedTheme);
    // },
  },
  mounted() {
    // this.initializeTheme(); // 初始化主题
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
/* .header {
  width: 100vw;
  height: 5rem;
  background: var(--background-color2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
  border-bottom: 1px solid var(--border-color2);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  .header_left {
    display: flex;
    align-items: center;
    .left_item {
      display: flex;
      align-items: center;
      width: 9.5rem;
      height: 3.5rem;
      border-radius: 0.5rem;
      margin-right: 1rem;
      justify-content: center;
      img {
        width: 1.5rem;
        height: 1.5rem;
        margin-right: 1rem;
      }
    }
    .active {
      background: var(--background-color3);
    }
  }
  .header_right {
    img {
      cursor: pointer;
      width: 2rem;
      height: 2rem;
    }
  }
} */
.bgcolor {
  background-color: #3385ff;
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#006eff),
    to(#13adff)
  );
  background-image: -webkit-linear-gradient(left, #006eff, #13adff);
  background-image: -o-linear-gradient(left, #006eff 0, #13adff 100%);
  background-image: linear-gradient(90deg, #006eff, #13adff);
  -webkit-box-shadow: 0 5px 10px 0 rgba(16, 110, 253, 0.3);
  box-shadow: 0 5px 10px 0 rgba(16, 110, 253, 0.3);
  color: #fff !important;
}
.mengban {
  width: 100%;
  height: 100%;
  background: #00000050;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .loginbox {
    width: 960px;
    height: 460px;
    background: #fff;
    display: flex;
    position: relative;
    .loginbox_left {
      width: 40%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 30px;
      box-sizing: border-box;
      justify-content: space-between;
      @media (max-width: 768px) {
        width: 100%;
      }
      .login_title {
        font-size: 2rem;
        line-height: 1.3;
        text-align: center;
        color: #333;
        @media (max-width: 768px) {
          font-size: 16px;
        }
      }
      .title_minor {
        margin-bottom: 20px;
        em {
          display: inline-block;
          width: 45px;
          height: 0px;
          border-bottom: 1px solid rgba(221, 221, 221, 1);
          vertical-align: middle;
        }
        span {
          list-style: none;
          font-size: 12px;
          color: #888888;
          margin: 0 18px 20px 18px;
        }
      }
      .input_box {
        width: 100%;
        display: flex;
        align-items: center;
        height: 40px;
        border-radius: 4px;
        img {
          width: 20px;
          height: 20px;
        }
        input {
          border: none;
        }
      }
      .login_btn {
        width: 100%;
        margin-top: 20px;
        text-align: center;
        height: 40px;
        border-radius: 4px;
        font-size: 15px;
        line-height: 40px;
        cursor: pointer;
      }
      .tishi_btn {
        width: 100%;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background: #d8eafc;
        color: #1e87f0;
        border-radius: 4px;
        margin-top: 20px;
        @media (max-width: 768px) {
          font-size: 16px;
        }
      }
      .bottom_box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.875rem;
        line-height: 1.5;
        color: #999;
        margin-top: 20px;
        @media (max-width: 768px) {
          font-size: 16px;
        }
        .box_left {
          cursor: pointer;
        }
        .box_right {
          cursor: pointer;
        }
      }
    }
    .cha {
      width: 30px;
      height: 30px;
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }
    .loginbox_right {
      width: 60%;
      height: 100%;
      @media (max-width: 768px) {
        display: none;
      }
      background: url("/src/assets/login/loginright.png") top center no-repeat;
    }
  }
  .registerbox {
    height: 580px;
    .xieyi {
      width: 100%;
      display: flex;
      align-items: center;
      color: #888888;
      @media (max-width: 768px) {
        font-size: 16px;
      }
      .agreen_btn {
        margin-right: 10px;
      }
      a {
        color: #888888;
        text-decoration: none;
        @media (max-width: 768px) {
          font-size: 16px;
        }
      }
    }
  }
  .userinfobox {
    width: 960px;
    /* height: 460px; */
    background: #fff;
    padding: 30px;
    border-radius: 4px;
    position: relative;
    .guanbi {
      width: 30px;
      height: 30px;
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
    }
    /* display: flex; */
    .userinfo {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      .userinfo_left {
        display: flex;
        align-items: center;
        img {
          margin-right: 20px;
          height: 80px;
          width: 80px;
          border-radius: 40px;
        }
        .userinfo_name {
          margin-bottom: 10px;
        }
        .tishi1 {
          color: #999;
          font-size: 0.875rem;
          line-height: 1.5;
        }
      }
      .userinfo_right {
        height: 40px;
        width: 100px;
        border-radius: 4px;
        text-align: center;
        line-height: 40px;
      }
    }
    .infobox_item {
      display: flex;
      margin-bottom: 20px;
      .input_box {
        width: 50%;
        box-sizing: border-box;
        padding-left: 15px;
        .input_name {
          color: #999;
          line-height: 1.5;
          margin-bottom: 10px;
          @media (max-width: 768px) {
            font-size: 16px;
          }
        }
      }
    }
    .tishi2 {
      line-height: 1.5;
      padding-left: 15px;
      margin-bottom: 20px;
      color: red;
      @media (max-width: 768px) {
        font-size: 16px;
      }
      span {
        color: #999;
      }
    }
    .baocun {
      width: 100px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      margin-left: 15px;
      border-radius: 4px;
      @media (max-width: 768px) {
        font-size: 16px;
      }
    }
  }
  .qrcodebox {
    background: #ffffff80;
    padding: 30px;
    border-radius: 4px;
    position: relative;
    .cha {
      width: 30px;
      height: 30px;
      position: absolute;
      right: 4px;
      top: 4px;
      cursor: pointer;
    }
  }
}
footer {
  background-color: #222;
  width: 100%;
  .ceo_grid {
    display: flex;
    padding: 1.875rem; /* 30px -> 1.875rem */
    width: 100%;
    box-sizing: border-box;
    .ceo_grid1 {
      width: 33%;
      img {
        width: 15rem;
      }
      p {
        color: #676b6f;
        font-size: 1rem;
        line-height: 1.5;
        margin-top: 0.625rem; /* 10px -> 0.625rem */
      }
    }
    .ceo_grid2 {
      width: 66%;
      display: flex;
      color: #676b6f;
      .ceo_width_1_3 {
        width: 33%;
        .foot_item_title {
          font-size: 1rem; /* 16px -> 1rem */
          margin-bottom: 0.625rem; /* 10px -> 0.625rem */
        }
        .ceo_padding_remove {
          li {
            font-size: 0.75rem; /* 12px -> 0.75rem */
            margin-bottom: 0.625rem; /* 10px -> 0.625rem */
            float: left;
            width: 50%;
          }
        }
      }
    }
    ul,
    li {
      list-style: none;
    }
    a {
      color: inherit;
      text-decoration: none;
    }
  }
  .foot_cop {
    width: 100%;
    box-sizing: border-box;
    background: #25282a;
    color: #676b6f;
    font-size: 0.8125rem; /* 13px -> 0.8125rem */
    padding: 0.9375rem; /* 15px -> 0.9375rem */
    display: flex;
    justify-content: space-between;
    align-items: center;
    a {
      color: #676b6f;
      text-decoration: none;
    }
    img {
      width: 1rem; /* 16px -> 1rem */
      height: 1.25rem; /* 20px -> 1.25rem */
      display: inline-block;
      transform: translateY(0.2rem); /* 20px -> 1.25rem */
      position: relative;
      margin-right: 0.1875rem; /* 3px -> 0.1875rem */
    }
  }
}
</style>
